// extracted by mini-css-extract-plugin
export default {"general":"Tabs_general__FEEC2","tab":"Tabs_tab__wfbCP","tab1":"Tabs_tab1__F9m4L","tabs":"Tabs_tabs__RTjYN"};